
import React from "react"
import { api_freedom } from '../services/apis'
import jwt_decode from 'jwt-decode'
import moment from 'moment'

class Contrato extends React.Component {

  constructor(props) {
    super(props)
    if (!localStorage.getItem('autenticado_freedom')) {
      props.history.push('/')
    }

    this.state = {
      dados_login: jwt_decode(localStorage.getItem('autenticado_freedom')),
      contrato: {},
      valor_calcao: '',
      responsabilidade: '',
      tipo_garantia: '',
      contem_garantia: 2,
      seguro: "",
      fiadores: [{ fiador: '', cpf_fiador: '', fiador_id: '', telefone: '', celular: '' }],
      titulo: "",
      vigencia_inicial_seguro: "",
      vigencia_final_seguro: "",
      valor_garantia: 0,
    }

  }

  componentDidMount() {
    this.contrato()
  }

  contrato = async () => {
    try {
      let contrato = await api_freedom.get(`/contrato/detalhe/${this.props.match.params.id}/${jwt_decode(localStorage.getItem('autenticado_freedom')).imobiliaria_id}`, { headers: { "authorization": localStorage.getItem('autenticado_freedom') } })
      this.setState({ contrato: contrato.data.data[0] })
      this.setState({
        fiadores: contrato.data.data[0].fiadores ? JSON.parse(contrato.data.data[0].fiadores) : this.state.fiadores,
        contem_garantia: contrato.data.data[0].contem_garantia,
        valor_calcao: contrato.data.data[0].valor_calcao,
        responsabilidade: contrato.data.data[0].responsabilidade,
        tipo_garantia: contrato.data.data[0].contem_garantia == 1 ? contrato.data.data[0].tipo_garantia : 1,
        seguro: contrato.data.data[0].seguro_fianca,
        valor_garantia: contrato.data.data[0].valor_garantia,
        vigencia_inicial_seguro: contrato.data.data[0].vigencia_inicial_seguro,
        vigencia_final_seguro: contrato.data.data[0].vigencia_final_seguro,
        titulo: contrato.data.data[0].titulo,
        contem_garantia: contrato.data.data[0].contem_garantia
      })
    }
    catch (error) {
      console.log(error.message)
    }
  }


  render() {
    return (
      <>
        <div>
          <h2 style={{ marginTop: '15px' }}>Dados do contrato</h2>
          <strong>Contrato</strong>: {this.state.contrato.id}<br />
          <strong>Início</strong>: {moment(this.state.contrato.data_inicio).format('DD/MM/YYYY')}<br />
          <strong>Término</strong>: {moment(this.state.contrato.data_fim).format('DD/MM/YYYY')}<br />
          <strong>Valor de aluguel</strong>: {this.state.contrato.valor_aluguel && this.state.contrato.valor_aluguel.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}<br />
          <strong>Tipo de locação</strong>: {this.state.contrato.tipo_locacao}<br />
          {this.state.contrato.taxa_fixa === 1 ? (
        <span>
          <strong>Valor da taxa de administração</strong>: {this.state.contrato.valor_taxa_fixa && this.state.contrato.valor_taxa_fixa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}<br />
        </span>
          ) : (
        <span>
          <strong>Percentual da taxa de administração</strong>: {this.state.contrato.perc_taxa_administracao}%<br />
        </span>
          )}
          <strong>Número de parcelas</strong>: {this.state.contrato.financeiro && this.state.contrato.financeiro.filter((f) => {
        return f.nome_servico === 'Locação'
          }).length}

                <hr />
                <h2 style={{ marginTop: '15px' }}>Dados do imóvel</h2>
                <strong>CEP</strong>: {this.state.contrato.imovel && this.state.contrato.imovel[0].cep}<br />
                <strong>Logradouro</strong>: {this.state.contrato.imovel && this.state.contrato.imovel[0].endereco}<br />
                <strong>Número</strong>: {this.state.contrato.imovel && this.state.contrato.imovel[0].numero}<br />
                <strong>Complemento</strong>: {this.state.contrato.imovel && this.state.contrato.imovel[0].complemento}<br />
                <strong>Bairro</strong>: {this.state.contrato.imovel && this.state.contrato.imovel[0].bairro}<br />
                <strong>Cidade</strong>: {this.state.contrato.imovel && this.state.contrato.imovel[0].cidade}<br />
                <strong>Estado</strong>: {this.state.contrato.imovel && this.state.contrato.imovel[0].estado}<br />

                <hr />
                <h2 style={{ marginTop: '15px' }}>Dados das pessoas</h2>
                {this.state.contrato.pessoas && this.state.contrato.pessoas
                .filter((p) => p.tipo === 'Locador')
                .map((p, idx) => (
                  <div key={`locador-${idx}`}>
                  <strong>Tipo</strong>: {p.tipo}<br />
                  <strong>Nome/Razão Social</strong>: {p.nome}<br />
                  <strong>CPF/CNPJ</strong>: {p.cpf_cnpj}<br />
                  <strong>Email</strong>: {p.email}<br />
                  <strong>Telefone(s)</strong>: {p.telefone}<br />
                  <strong>Celular(es)</strong>: {p.celular}<br />
                  <strong>Banco</strong>: {p.banco}<br />
                  <strong>Agência</strong>: {p.agencia}<br />
                  <strong>Conta</strong>: {p.conta}<br />
                  <hr />
                  </div>
                ))}
                {this.state.contrato.pessoas && this.state.contrato.pessoas
                .filter((p) => p.tipo === 'Locatário')
                .map((p, idx) => (
                  <div key={`locatario-${idx}`}>
                  <strong>Tipo</strong>: {p.tipo}<br />
                  <strong>Nome/Razão Social</strong>: {p.nome}<br />
                  <strong>CPF/CNPJ</strong>: {p.cpf_cnpj}<br />
                  <strong>Email</strong>: {p.email}<br />
                  <strong>Telefone(s)</strong>: {p.telefone}<br />
                  <strong>Celular(es)</strong>: {p.celular}<br />
                  <hr />
                  </div>
                ))}
          <h2 style={{ marginTop: '15px' }}>Dados das garantias</h2>
          {this.state.contem_garantia == 2 && (
        <div >
          <strong>Tipo</strong>: Não há garantia para este contrato!<br />
          <hr />
        </div>
          )}
          {this.state.contem_garantia == 1 && this.state.tipo_garantia == 1 && (
        <div >
          <strong>Tipo</strong>: Seguro fiança<br />
          <strong>Seguro fiança</strong>: {this.state.seguro}<br />
          <strong>Data inicial</strong>: {moment(this.state.vigencia_inicial_seguro).format('DD/MM/YYYY')}<br />
          <strong>Data final</strong>: {moment(this.state.vigencia_final_seguro).format('DD/MM/YYYY')}<br />
          <strong>Valor garantia</strong>: {this.state.valor_garantia}<br />
          <hr />
        </div>
          )}
          {this.state.contem_garantia == 1 && this.state.tipo_garantia == 3 && (
        <div >
          <strong>Tipo</strong>: Título<br />
          <strong>Título</strong>: {this.state.titulo}<br />
          <strong>Data inicial</strong>: {moment(this.state.vigencia_inicial_seguro).format('DD/MM/YYYY')}<br />
          <strong>Data final</strong>: {moment(this.state.vigencia_final_seguro).format('DD/MM/YYYY')}<br />
          <strong>Valor garantia</strong>: {this.state.valor_garantia}<br />
          <hr />
        </div>
          )}
          {this.state.contem_garantia == 1 && this.state.tipo_garantia == 4 && (
        <div >
          <strong>Tipo</strong>: Caução<br />
          <strong>Valor Caução</strong>: {this.state.valor_calcao}<br />
          <strong>Responsabilidade</strong>: {this.state.responsabilidade}<br />
          <hr />
        </div>
          )}
          {this.state.contem_garantia == 1 && this.state.tipo_garantia == 2 && this.state.fiadores.map((fiador, index) => {
        return (
          <div >
          <strong>Tipo</strong>: Fiador<br />
          <strong>Nome</strong>: {fiador.fiador}<br />
          <strong>CPF/CNPJ do fiador</strong>: {fiador.cpf_fiador}<br />
          <strong>Telefone</strong>: {fiador.telefone}<br />
          <strong>Celular</strong>: {fiador.celular}<br />
          <hr />
        </div>
        )
          })} 
        </div>
      </>
        );
  }
}

export default Contrato;
